'use client'

import dynamic from 'next/dynamic'

export const DeliveryMapBlockLazy = dynamic(
  () => import('./delivery-map-block').then(m => m.DeliveryMapBlock),
  {
    ssr: false,
    loading: () => <div style={{height: 600}} />,
  },
)
